import React from "react";

const IndustriesSection = ({ data }) => {
  // Data Validation
  const industries = data?.industries;
  if (!industries) return null;

  return (
    <section className="sky-ws-content-section sky-ind-section">
      <div className="container">
        {/* Main Section Heading */}
        {industries.industries_heading && (
          <h2 className="sky-ind-main-title">
            {industries.industries_heading}
          </h2>
        )}

        {/* Dynamic Cards Grid */}
        <div className="row justify-content-center g-4">
          {industries.industries_list?.map((item, index) => (
            /* col-lg-4 ka matlab hai 12 column me se 4-4-4 ke 3 blocks banenge */
            <div className="col-12 col-md-6 col-lg-6 col-xl-3 justify-content-center d-flex" key={index}>
              <div className="sky-ind-card">
                <div className="sky-ind-img-box">
                  <img
                    src={item.image_url}
                    alt={item.industries_heading}
                    loading="lazy"
                  />
                </div>

                <div className="sky-ind-title-tray">
                  <h4 className="sky-ind-card-title text-capitalize">
                    {item.industries_heading}
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
